import { render } from "./EmployeePendingLiquidations.vue?vue&type=template&id=c8278cec"
import script from "./EmployeePendingLiquidations.vue?vue&type=script&lang=js"
export * from "./EmployeePendingLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__